import { getDomElementAsNotNullable } from "../../utils/layoutUtils";
/**
 *
 * Manages the highlighting of the current sidebar element.
 *
 * */
export class Sidebar {
    constructor() {
        let sidebar = getDomElementAsNotNullable("mySidebar");
        this.cards = sidebar.getElementsByTagName("a");
        let self = this;
        //Hacky workaround. Not sure why intersection observer doesn't work!
        for (let card of this.cards) {
            card.addEventListener("click", (e) => {
                Array.from(self.cards).forEach(c => {
                    c.style.backgroundColor = "transparent";
                    c.style.color = "#818181";
                });
                card.style.backgroundColor = 'lightblue';
                card.style.color = 'white';
            });
        }
    }
}
